import { styled as f, css as i } from "styled-components";
import "react";
import { theme as t } from "../../styles/themes/index.js";
const n = ({ $variant: e }) => e === "h1" ? t["--ll-font-size-h1"] : e === "h2" ? t["--ll-font-size-h2"] : e === "h3" ? t["--ll-font-size-h3"] : e === "h4" ? t["--ll-font-size-h4"] : e === "h5" ? t["--ll-font-size-h5"] : e === "h6" ? t["--ll-font-size-h6"] : e === "p" ? t["--ll-font-size-p"] : e === "caption1" ? t["--ll-font-size-caption-1"] : e === "caption2" ? t["--ll-font-size-caption-2"] : t["--ll-font-size-h2"], l = ({ $color: e }) => e in t ? t[e] : e, o = f.span`
  overflow: hidden;
  display: inline-block;
  width: 100%;
  line-height: ${({ $lineHeight: e }) => e || 1.45};
  margin: 0 0 ${({ $noMargin: e }) => e ? "0" : "0.5em"} 0;
  font-size: inherit;
  font-weight: inherit;
`, m = f.div`
  ${(e) => i`
    text-align: ${e.$align};
    font-size: ${n(e)};
    font-family: ${e.$family === "sans-serif" ? t["--ll-font-family"] : t["--ll-font-family-mono"]};
    font-variant: ${e.$fontVariant};
    letter-spacing: ${e.$letterSpacing};
    color: ${l(e)};
    font-weight: ${t[e.$weight]};
    text-transform: ${e.$textTransform};
    overflow: hidden;
    display: flex;

    svg {
      height: ${n(e)};
      fill: ${l(e)};
    }

    ${o} {
      ${e.$lineClamp && i`
        ${e.$lineClamp === 1 ? `
              white-space: nowrap;
            ` : `
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: ${e.$lineClamp};
            `}
        overflow: hidden;
        text-overflow: ellipsis;
      `}
    }
  `}
`;
export {
  m as Text,
  o as TextWrap
};
